import { createSelector } from 'reselect';

import { getPopper } from './getPopper';

export const getPopperLocation = createSelector(
  getPopper,
  popper => popper.location,
);
